package com.example.readingnotes.presentation.auth

import com.example.readingnotes.domain.model.User
import com.example.readingnotes.domain.repository.UserProfile

data class AuthUiState(
    val isLoading: Boolean = false,
    val isLoggedIn: Boolean = false,
    val errorMessage: String? = null,
    val passwordInput: String = "",
    // New fields for username authentication
    val usernameInput: String = "",
    val user: User? = null,
    val usernameAvailable: Boolean? = null, // null = not checked, true = available, false = taken
    val usernameChecking: Boolean = false, // loading state for username check
    // TOTP fields
    val totpCodeInput: String = "",
    val totpRequired: Boolean = false,
    val totpVerified: Boolean = false,
    val totpSetupSecret: String? = null,
    val totpSetupQrCodeUrl: String? = null,
    // Email authentication fields
    val emailInput: String = "",
    val verificationCodeInput: String = "",
    val verificationCodeSent: Boolean = false,
    val emailVerified: Boolean = false,
    val tempEmail: String = "", // temporary email during registration flow
    val tempVerificationCode: String = "", // temporary verification code during registration flow
    // OIDC authentication fields
    val oidcAuthorizationUrl: String? = null, // authorization URL for OIDC redirect
    val oidcState: String? = null, // state parameter for CSRF protection
    val oidcCodeVerifier: String? = null, // PKCE code verifier
    val oidcPendingLogin: Boolean = false, // true when OIDC login is in progress
    // Profile management fields
    val userProfile: UserProfile? = null, // user profile data
    val profileUsernameInput: String = "", // username input in profile completion
    val profileDisplayNameInput: String = "", // display name input in profile completion
    val profileSaving: Boolean = false, // true when saving profile
    val profileSaveSuccess: Boolean = false, // true when profile save succeeded
)
